import styled from "styled-components";
import { COLORS } from "../../../../../styles/constants.style";

export const CreateGenericAccountHeaderWrapper = styled.div`
  margin: 4px 0px 0px;
  .header-left {
    display: flex;
    .line {
      display: block;
      width: 2px;
      height: 48px;
      border: 3px solid ${COLORS.primary_light_blue3};
      border-radius: 4px;
    }
    .text {
      font-size: 24px;
      font-weight: 700;
      line-height: 24px;
      padding-left: 8px;
      margin-top: 10px;
    }
  }
  .header-right {
    align-items: center;
    display: flex;
    justify-content: end;
  }
  .header-edit-client {
    margin-left: 12px;
  }
  .header-view-hierarchy {
    height: auto;
    width: auto;
  }

  .hierarchyIcon {
    padding: 10px;
  }
`;
